import { request } from 'helpers'

export function getAnnualPassSettings(cancelToken) {
  return request.get('/annual/settings', cancelToken)
}

export function updateAnnualPassSettings(data) {
  return request.post('/annual/settings', data)
}

export function getMemberPassSettings(cancelToken) {
  return request.get('/membership/settings', cancelToken)
}

export function updateMemberPassSettings(data) {
  return request.post('/membership/settings', data)
}

export function getSeasonPassSettings(cancelToken) {
  return request.get('/season/settings', cancelToken)
}

export function updateSeasonPassSettings(data) {
  return request.post('/season/settings', data)
}

export function getPaymentSettings(cancelToken) {
  return request.get('/payment/settings', cancelToken)
}

export function updatePaymentSettings(data) {
  return request.post('/payment/settings/bambora', data)
}

export function importEventsFromElektra(data) {
  return request.post('/planner/member/importevents', data)
}
